import AxiosInitializer from 'api/Utility/AxiosInitializer'
import getToken, { getSessionToken } from 'lib/authentication/GetToken'
import apiWrapper from 'api/Utility/ApiWrapper'
import { EHQ_API_URL } from 'containers/TextAnalysis/Template'

const URL = `${EHQ_API_URL}`

const axios = (extraParams: Record<string, any> = {}) => {
  const token =
    process.env.NODE_ENV === 'production' ? getSessionToken() : getToken()

  return AxiosInitializer({
    token,
    transformResConfig: false,
    paramsSerializerConfig: true,
    ...extraParams,
    tool: 'text_analysis',
  })
}

interface QueryParams {
  [key: string]: any
}

interface UpdateThemeParams {
  themeId: string
  keyPhrases: string[]
}

const themesAPI = {
  postTheme: (queryParams: QueryParams) =>
    axios().post(`${URL}/themes`, queryParams),

  getTheme: (queryParams: QueryParams) =>
    axios().get(`${URL}/themes`, { params: queryParams }),

  updateTheme: ({ themeId, keyPhrases }: UpdateThemeParams) =>
    axios().patch(`${URL}/themes/${themeId}`, {
      data: {
        type: 'themes',
        id: themeId,
        attributes: { query: { attributes: { key_phrases: keyPhrases } } },
      },
    }),

  getAllPhrases: (queryParams: QueryParams) =>
    axios().get(`${URL}/key_phrases`, { params: queryParams }),

  deleteTheme: ({ themeId }: QueryParams) =>
    axios().delete(`${URL}/themes/${themeId}`),
}

const taThemesAPI = {
  postThemes: (params = {}) =>
    apiWrapper({ endPoint: themesAPI.postTheme, params }),
  getThemes: (params = {}) =>
    apiWrapper({ endPoint: themesAPI.getTheme, params }),
  updateThemes: (params = {}) =>
    apiWrapper({ endPoint: themesAPI.updateTheme, params }),
  getAllPhrases: (params = {}) =>
    apiWrapper({ endPoint: themesAPI.getAllPhrases, params }),
  deleteTheme: (params = {}) =>
    apiWrapper({ endPoint: themesAPI.deleteTheme, params }),
}

export { themesAPI }
export default taThemesAPI
